export const MAIN_ID = 'main';

/** First focusable element on every page: jumps past the navigation. */
export function SkipLink() {
  return (
    <a
      href={`#${MAIN_ID}`}
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-accent focus:px-4 focus:py-2 focus:text-paper"
    >
      Skip to content
    </a>
  );
}
